
/**
 * Cache to register v_company
 * @kind cache
 * @class 
 * @description Custom lookup cache for 
 * @usage let lookup = await Grape.cache.get('ContractTypeLookup');
 */
export default {
	name: 'CompanyLookup',
	options: {
		schema: 'public',
		table: 'company'
	}
};
